/**
 * Soundium — FX-aware static money amounts (SND-10931).
 *
 * Theme copy sometimes states fixed money figures that the storefront cannot
 * convert on its own — e.g. "Free delivery over €149", "Shipping from €4",
 * the header "Free EU shipping over €149". Product prices auto-convert through
 * Shopify Markets, but a literal €149 baked into a sentence stays in euros and
 * looks wrong to a shopper paying in kr / zł.
 *
 * This rewrites any element carrying `data-snd-fx="<eur-amount>"` into the
 * visitor's active presentment currency using Shopify's live market rate,
 * rounded to a clean figure with no decimals (per Vincas, SND-10931 #1).
 *
 * The element's existing text is the EUR baseline and stays untouched on euro
 * markets and when JS is unavailable, so nothing regresses for the €-markets.
 *
 *   <span data-snd-fx="149">€149</span>   → SE: "1 650 kr", PL: "640 zł", …
 *
 * Optional attributes:
 *   data-snd-fx-base="EUR"   currency the figure is written in (default EUR = shop base)
 *   data-snd-fx-round="1"    force a rounding step instead of the auto "nice" step
 *   data-snd-fx-dir="up|down" after rounding, never land below ("up") / above ("down") the exact
 *                            converted value — for thresholds ("orders over …" → up) and for
 *                            promised gifts ("€10 off" → down), SND-16622.
 */
(function () {
  var BASE_DEFAULT = 'EUR';

  function niceStep(v, step) {
    if (step && step > 0) return step;
    // Auto "nice" step scaled to magnitude — keeps figures clean, never shows cents.
    if (v < 20) return 1;
    if (v < 100) return 5;
    if (v < 1000) return 10;
    if (v < 10000) return 50;
    return 100;
  }

  function niceRound(v, step, dir) {
    var s = niceStep(v, step);
    var out = Math.round(v / s) * s;
    if (dir === 'up' && out < v) out += s;
    if (dir === 'down' && out > v) out -= s;
    return out;
  }

  function formatter(currency, locale) {
    var tries = [
      { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0, minimumFractionDigits: 0 },
      { style: 'currency', currency: currency, maximumFractionDigits: 0, minimumFractionDigits: 0 }
    ];
    for (var i = 0; i < tries.length; i++) {
      try { return new Intl.NumberFormat(locale, tries[i]); } catch (e) {}
    }
    return null;
  }

  function run() {
    var C = window.Shopify && window.Shopify.currency;
    if (!C) return;
    var active = String(C.active || '').toUpperCase();
    var rate = parseFloat(C.rate || '1');
    if (!active || !isFinite(rate) || rate <= 0) return;

    var locale = (document.documentElement.getAttribute('lang') || 'en').trim() || 'en';
    var fmtCache = {};

    var nodes = document.querySelectorAll('[data-snd-fx]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var base = parseFloat(el.getAttribute('data-snd-fx'));
      if (isNaN(base)) continue;
      var baseCur = (el.getAttribute('data-snd-fx-base') || BASE_DEFAULT).toUpperCase();

      // Same currency as the figure is written in → leave the euro baseline alone.
      if (active === baseCur) { el.removeAttribute('data-snd-fx-done'); continue; }
      if (el.getAttribute('data-snd-fx-done') === active) continue;

      var step = parseFloat(el.getAttribute('data-snd-fx-round')) || 0;
      var dir = (el.getAttribute('data-snd-fx-dir') || '').toLowerCase();
      var local = niceRound(base * rate, step, dir);

      var fmt = fmtCache[active] || (fmtCache[active] = formatter(active, locale));
      var out = fmt ? fmt.format(local) : (local.toLocaleString(locale) + ' ' + active);
      // "kr." + a sentence-ending "." would read "770 kr.." (da-DK) — drop the symbol's dot then.
      if (/\.$/.test(out)) {
        // Next node after the span — climbing out of inline wrappers such as <strong>.
        var n = el, ns = null;
        while (n && !ns && n !== document.body) { ns = n.nextSibling; if (!ns) n = n.parentNode; }
        var nsText = ns ? (ns.nodeType === 3 ? ns.nodeValue : ns.textContent) : '';
        if (/^\s*[.,;:]/.test(nsText || '')) out = out.replace(/\.$/, '');
      }

      el.textContent = out;
      el.setAttribute('data-snd-fx-done', active);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Theme editor / Section Rendering API re-renders.
  document.addEventListener('shopify:section:load', run);
  // Cart/localization changes can swap currency without a full reload.
  document.addEventListener('shopify:block:select', run);
})();

